var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagonalArrowRightUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " diagonal-arrow-right-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9932 7.57048C17.9932 7.02148 17.5493 6.57448 16.9993 6.57148L9.00625 6.52148H9.00025C8.45025 6.52148 8.00425 6.96548 8.00025 7.51548C7.99625 8.06748 8.44125 8.51848 8.99425 8.52148L14.5522 8.55648L6.29325 16.8145C5.90225 17.2055 5.90225 17.8385 6.29325 18.2285C6.48825 18.4245 6.74425 18.5215 7.00025 18.5215C7.25625 18.5215 7.51225 18.4245 7.70725 18.2285L15.9952 9.94048L16.0002 15.5225C16.0002 16.0745 16.4482 16.5215 17.0002 16.5215H17.0013C17.5533 16.5215 18.0002 16.0725 18.0002 15.5205L17.9932 7.57048Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagonalArrowRightUp);
export default __webpack_public_path__ + "static/media/diagonal-arrow-right-up.2a04e17e7755936bad24f41a5344b895.svg";
export { ForwardRef as ReactComponent };